import React from "react";
import { useSmoothScroll } from "../../hooks/useSmoothScroll";
import { NavLink } from "./NavbarConfig";

interface NavbarLinksProps {
  links?: NavLink[];
  activeSection?: string;
}

export function NavbarLinks({ links = [], activeSection = "" }: NavbarLinksProps) {
  const smoothScroll = useSmoothScroll();

  return (
    <ul className="nav__links">
      {links.map((link) => {
        const linkId = link.href.replace("#", "");
        const isActive = activeSection === linkId;

        return (
          <li key={link.href}>
            <a
              className={`nav__link ${isActive ? "nav__link--active" : ""}`}
              href={link.href}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => smoothScroll(e, link.href)}
            >
              {link.label}
            </a>
          </li>
        );
      })}
    </ul>
  );
}